export const visit = (vm, at) => {
at({ "sv": { "upgradePointTooltip": { "upgradePageLink_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, createElement( options, "Link", props, "Uppgradera" ), " f\xF6r att utf\xF6ra den h\xE4r \xE5tg\xE4rden." ); } } } });
};